import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
  formatCurrency,
  getStatusColor,
  getStatusTextColor,
} from "../../utilz/function";

interface OrderCustomer {
  contactName: string;
  email: string;
}
interface OrderData {
  _id: string;
  orderId: string;
  customer: OrderCustomer;
  source: string;
  status: string;
  totalAmount: number;
  paymentStatus: string;
}

interface UserTableProps {
  data: OrderData[];
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}
const OrderTable: React.FC<UserTableProps> = ({ data, selectedStatus }) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState<OrderData[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const columns = [
    { header: "Order ID", accessor: "orderId" },
    { header: "Customer", accessor: "contactName" },
    { header: "Source", accessor: "source" },
    { header: "Order Time", accessor: "createdAt" },
    { header: "Order Status", accessor: "status" },
    { header: "Amount", accessor: "totalAmount" },
    { header: "Payment", accessor: "paymentStatus" },
    { header: "Actions", accessor: "_id" },
  ];

  const handleUserClick = (_id: string) => {
    navigate(`/dashboard/order/${_id}`);
  };

  useEffect(() => {
    const filtered = data?.filter((order) => {
      const statusMatch = !selectedStatus || order?.status === selectedStatus;

      const searchMatch =
        !searchQuery ||
        order?.customer?.contactName
          ?.toLowerCase()
          .includes(searchQuery?.toLowerCase());
      const orderMatch = !selectedType || order?.status === selectedType;

      return statusMatch && searchMatch && orderMatch;
    });
    setFilteredData(filtered);
  }, [data, selectedStatus, searchQuery, selectedType]);

  const combinedData = filteredData?.map((order) => ({
    ...order,
    contactName: (
      <div>
        <div>{order?.customer?.contactName || "N/A"}</div>
      </div>
    ),
    paymentStatus: (
      <div>
        <span
          style={{
            color: getStatusTextColor(order?.paymentStatus),
            backgroundColor: getStatusColor(order?.paymentStatus),
          }}
          className="p-2"
        >
          {order?.paymentStatus || "N/A"}
        </span>
      </div>
    ),
    source: (
      <div>
        <span className="p-2 capitalize">{order?.source || "N/A"}</span>
      </div>
    ),
    totalAmount: (
      <div>
        <div>
          {formatCurrency(order?.totalAmount, "NGN", "symbol") || "N/A"}
        </div>
      </div>
    ),
  }));

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleOrderFilterChange = (selectedValue: string) => {
    setSelectedType(selectedValue);
  };

  return (
    <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
      <div className="md:flex justify-between px-5">
        <h2 className="text-[20px] font-bold">Orders</h2>

        <div className="md:flex gap-2 items-center md:mt-0 mt-2">
          <Input
            name="search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
            placeholder="Search"
            icon="searchIcon"
          />
          <FIlterSelect
            name="filter"
            options={[
              { label: "All", value: "" },
              { label: "Pending", value: "pending" },
              { label: "Completed", value: "completed" },
              { label: "Cancelled", value: "cancelled" },
            ]}
            value={selectedType}
            onChange={handleOrderFilterChange}
            className="mt-2 md:-mt-2 w-full md:w-[50%]"
            icon="filterIcon"
          />
        </div>
      </div>

      {combinedData?.length > 0 ? (
        <Table
          columns={columns}
          data={combinedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="opacity-80 mt-10 font-bold text-center mx-auto">
          No Order found
        </div>
      )}
    </div>
  );
};

export default OrderTable;
